import { deserialize, object, list, serialize, primitive } from 'serializr';
import WatchAgent from './watchagent-model';
import Coordinator from './../coordinators/coordinator-model';
import ResourceBase from './../shared/resource-base';
import ModelSchemas from './../shared/model-schema';
import AgentProfile from '../agent-profile/agent-profile-model';

export default class WatchAgentResource extends ResourceBase {
    constructor() {
        super(WatchAgent);
        this.schema = ModelSchemas.createWatchAgentSchema(WatchAgent, {
            watchAgentId: primitive(),
            agentProfile: object(AgentProfile),
            coordinatorId: primitive(),
            coordinator: object(Coordinator),
        });
    }

    getWatchAgentsByCoordinatorId(token, coordinatorId) {
        return new Promise((resolve, reject) => {
            const query = { filter: { where: { coordinatorId: coordinatorId } } };
            this.find(token, query)
                .then(watchAgentJson => {
                    let watchAgentModels = [];
                    watchAgentJson.forEach(watchAgent => {
                        watchAgentModels.push(deserialize(this.schema, watchAgent));
                    });
                    resolve(watchAgentModels);
                })
                .catch(reject);
        });
    }

    getWatchAgents(token) {
        return new Promise((resolve, reject) => {
            this.getAll(token)
                .then(watchAgentJson => {
                    let watchAgentModels = [];
                    watchAgentJson.forEach(watchAgent => {
                        watchAgentModels.push(deserialize(this.schema, watchAgent));
                    });
                    resolve(watchAgentModels);
                })
                .catch(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/agents/watchagent-resource.js